import { formatTwitterHandle, getTwitterUrl } from '@/helpers/common';
import { AbstractModel } from '@/models/abstractModel';
import type { ICustomTeamPageApi } from '@/types/team';

export class CustomTeamItem extends AbstractModel {
    public countryId: number | null = null;
    public countryName: string | null = null;
    public createdAt: string = '';
    public deletedAt: string | null = null;
    public gameCount: number = 0;
    public id: number = 0;
    public imagePath: string | null = null;
    public isImageChangedManually: 0 | 1 = 0;
    public isUseTradeball: 0 | 1 = 0;
    public name: string = '';
    public shortCode: string | null = null;
    public sportId: number = 0;
    public twitter: string | null = null;
    public typeId: number | null = null;
    public updatedAt: string = '';
    public wikiLink: string | null = null;
    public women: 0 | 1 = 0;
    public youth: 0 | 1 = 0;

    constructor(data?: ICustomTeamPageApi) {
        super();

        if (!data) {
            return;
        }

        this.id = data.id;
        this.createdAt = data.created_at;
        this.updatedAt = data.updated_at;
        this.deletedAt = data.deleted_at;
        this.name = data.name;
        this.sportId = data.sport_id;
        this.countryId = data.country_id ?? null;
        this.countryName = data.country_name;
        this.typeId = data.type_id;
        this.women = data.women;
        this.youth = data.youth;
        this.wikiLink = data.wiki_link;
        this.shortCode = data.short_code;
        this.imagePath = data.image_path;
        this.isImageChangedManually = data.is_image_changed_manually;
        this.isUseTradeball = data.is_use_tradeball;
        this.twitter = data.twitter;
        this.gameCount = data.game_count;
    }

    get twitterUrl(): string | null {
        return getTwitterUrl(this.twitter);
    }

    toApiData(): Record<string, unknown> {
        const isCreate = this.id <= 0;
        const row: Record<string, unknown> = {
            name: this.name.trim(),
            type_id: this.typeId,
            women: this.women,
            youth: this.youth,
            country_id: this.countryId,
            wiki_link: this.wikiLink?.trim() || null,
            twitter: formatTwitterHandle(this.twitter),
        };

        if (isCreate) {
            row.sport_id = this.sportId;
        } else {
            row.id = this.id;
        }

        return row;
    }
}
